import { render, staticRenderFns } from "./acuerdo-comision.vue?vue&type=template&id=0e4d2722&"
import script from "./acuerdo-comision.vue?vue&type=script&lang=js&"
export * from "./acuerdo-comision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports